import { Container, Typography } from '@mui/material'
import React from 'react'
import styles from './trackingResponsibleStyles'

const TrackingResponsible = ({guide}) => {
  return (
    <Container style={styles.mainContainer}>
      <Typography variant="h6" sx={styles.title}>Responsable</Typography>
      <Container sx={styles.secondaryContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="h6" sx={styles.data}>{guide?.guide_info?.last_owner ?? 'Desconocido'}</Typography>
        </Container>
      </Container>
    </Container>
  )
}

export default TrackingResponsible